import axios from "axios";
import { Config } from "../../data/config";
import { setConnection } from './connection';

export const SET_PROMOTION_INFO = "PROMOTION_INFO | SET_PROMOTION_INFO";
export const SET_REDIRECT_404 = "PROMOTION_INFO | SET_REDIRECT_404";
export const SET_STATUS_TYPE = "PROMOTION_INFO | SET_STATUS_TYPE";
export const RESET_PROMOTION_INFO = "PROMOTION_INFO | RESET_PROMOTION_INFO";
export const SET_BUILDING_DATA = "PROMOTION_INFO | SET_BUILDING_DATA";

export function retrievePromoInfo(code) {
  return function (dispatch) {
    axios
      .get(`${Config.frontApiUrl}/availability/promo/${code}`)
      .then(response => {
        dispatch(setPromotionInfo(response.data.promo));
        dispatch(status200(true));
      })
      .catch(error => {
        dispatch(redirect404(true));
      });
  }
}

export function getBuildingData(code) {
  return function (dispatch) {
    axios
      .get(`${Config.frontApiUrl}/availability/promo/${code}/building`)
      .then(response => {
        dispatch(setConnection(response.data.building));
      })
  }
}

export function setBuildingData(payload) {
  return { type: SET_BUILDING_DATA, payload }
}
export function redirect404(payload) {
  return { type: SET_REDIRECT_404, payload };
}
export function status200(payload) {
  return { type: SET_STATUS_TYPE, payload };
}

export function setPromotionInfo(payload) {
  return { type: SET_PROMOTION_INFO, payload }
}

export function resetPromoInfo() {
  return { type: RESET_PROMOTION_INFO }
}



// WEBPACK FOOTER //
// ./src/store/actions/promotionInfo.js